import { render, staticRenderFns } from "./500.vue?vue&type=template&id=1dd77772&scoped=true"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"
import style0 from "./500.vue?vue&type=style&index=0&id=1dd77772&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd77772",
  null
  
)

export default component.exports